import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=158cdcdc&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=158cdcdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports